module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('confirm', {
    attrs: {
      "text": "去选择支付方式？"
    },
    on: {
      "on-sure": _vm.payConfirm
    },
    model: {
      value: (_vm.showPayConfirm),
      callback: function($$v) {
        _vm.showPayConfirm = $$v
      },
      expression: "showPayConfirm"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49197e93","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PayConfirm.vue
// module id = 828
// module chunks = 0